import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useAverageLotValueActionCalendarRanking = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.AverageLotValueActionCalendarRanking,
        AmplitudeVariants.AverageLotValueActionCalendarRanking.Treatment
    );
